import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";

import { AppComponent } from "./app.component";
import { LayoutComponent } from "../layout/layout.component";
import { environment } from "../../environments/environment";

import { AuthComponent } from "../pages/shared/auth/auth.component";

import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "../shared/shared.module";
import { BreadcrumbsComponent } from "../layout/breadcrumbs/breadcrumbs.component";

// Discussion services
import {
  DiscussionService,
  CommentService,
  BookmarkService,
  PanelService,
  DiscussionVoteService,
  CommentVoteService,
} from "../shared";

// Community services
import { CommunityService, MemberService } from "../shared";

// App modules
import {
  ApiService,
  UserService,
  JwtService,
  AuthGuard,
  MenuService,
  ProfileService,
  TagService,
  InviteService,
  NotificationService,
  HttpTokenInterceptor,
  HttpCredentialInterceptor,
  HttpXsrfInterceptor,
  SocketService,
  RouteEventsService,
} from "../shared";

import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AngularFireModule } from "@angular/fire";
import { AngularFireStorageModule } from "@angular/fire/storage";

// -------------------------------------------------------------------------------
// shared
// -------------------------------------------------------------------------------
import { AppInfoModule } from "../pages/shared/app-info/app-info.module";
import { AuthModule } from "../pages/shared/auth/auth.module";
import { ErrorModule } from "../pages/shared/error/error.module";
import { InviteManagerModule } from "../pages/shared/invite-manager/invite-manager.module";
import { ProfileModule } from "../pages/shared/profile/profile.module";
import { SettingsModule } from "../pages/shared/settings/settings.module";
// -------------------------------------------------------------------------------
// communities
// -------------------------------------------------------------------------------
import { CommunityViewerModule } from "../pages/communities/community-viewer/community-viewer.module";
import { CommunityEditorModule } from "../pages/communities/community-editor/community-editor.module";
// -------------------------------------------------------------------------------
// discussions
// -------------------------------------------------------------------------------
import { DiscussionViewerModule } from "../pages/discussions/discussion-viewer/discussion-viewer.module";
import { DiscussionEditorModule } from "../pages/discussions/discussion-editor/discussion-editor.module";
import { DiscussionFeedModule } from "../pages/discussions/discussion-feed/discussion-feed.module";

const COMPONENTS: any[] = [
  AppComponent,
  LayoutComponent,
  AuthComponent,
  BreadcrumbsComponent,
];

const MODULES = [
  BrowserModule,
  BrowserAnimationsModule,
  AppRoutingModule,
  SharedModule,
  AngularFireModule.initializeApp(environment.firebaseConfig),
  AngularFireStorageModule,
  AppInfoModule,
  AuthModule,
  CommunityViewerModule,
  CommunityEditorModule,
  DiscussionViewerModule,
  DiscussionEditorModule,
  DiscussionFeedModule,
  ErrorModule,
  InviteManagerModule,
  ProfileModule,
  SettingsModule,
];

const PROVIDERS: any[] = [
  { provide: HTTP_INTERCEPTORS, useClass: HttpTokenInterceptor, multi: true },
  {
    provide: HTTP_INTERCEPTORS,
    useClass: HttpCredentialInterceptor,
    multi: true,
  },
  // { provide: HTTP_INTERCEPTORS, useClass: HttpXsrfInterceptor, multi: true },
  // shared
  ApiService,
  JwtService,
  AuthGuard,
  MenuService,
  UserService,
  ProfileService,
  TagService,
  InviteService,
  NotificationService,
  SocketService,
  RouteEventsService,
  // discussions
  DiscussionService,
  CommentService,
  BookmarkService,
  PanelService,
  DiscussionVoteService,
  CommentVoteService,
  // communities
  CommunityService,
  MemberService,
];

@NgModule({
  declarations: [COMPONENTS],
  imports: [MODULES],
  providers: [PROVIDERS],
  bootstrap: [AppComponent],
})
export class AppModule {}
